import Utils from 'services/utils';

export default class TreeController {
    /** @ngInject */
    constructor(EventEmitter, FolderService, treeConfig, $timeout, $scope) {
        this.eventEmitter = EventEmitter;
        this.FolderService = FolderService;
        this.treeConfig = treeConfig;
        this.$timeout = $timeout;
        this.$scope = $scope;
    }

    $onInit() {
        this.treeConfig.dragClass = 'angular-ui-tree-drag ui-tree--folder';
        this.treeOptions = {
            beforeDrop: this.treeBeforeDrop.bind(this)
        };
    }

    expandAll() {
        this.$scope.$broadcast('angular-ui-tree:expand-all');
    }

    collapseAll() {
        this.$scope.$broadcast('angular-ui-tree:collapse-all');
    }

    onPostDigest() {
        return this.$timeout(Utils.noop, 0);
    }

    treeBeforeDrop({ source: { nodeScope: srcScope }, dest: { nodesScope: dstScope, index } }) {
        const { $modelValue: sourceFolder } = srcScope;
        let parentFolder = null;
        if (dstScope.$nodeScope) {
            parentFolder = dstScope.$nodeScope.$modelValue;
        }
        this.onFolderMoved(
            this.eventEmitter({
                folder: sourceFolder,
                parent: parentFolder,
                index
            })
        );
        return false;
    }

    $onChanges({ selectedFolderId }) {
        if (selectedFolderId && selectedFolderId.currentValue) {
            this.expandFolderPath(selectedFolderId.currentValue);
        }
    }

    enableReorderMode() {
        this.reorderMode = true;
    }

    disableReorderMode() {
        this.reorderMode = false;
    }

    initTreeScope(scope) {
        this.treeScope = scope;
    }

    expandFolderPath(folderId) {
        this.onPostDigest().then(() => {
            if (this.treeScope.$nodesScope) {
                const folderPath = this.FolderService.buildFolderPath(folderId);
                folderPath.reduce((parentScope, folder) => {
                    const childNodes = parentScope.childNodes();
                    const [scope] = childNodes.filter(({ $modelValue }) => $modelValue && $modelValue.id === folder.id);
                    if (scope) {
                        scope.expand();
                    }
                    return scope;
                }, this.treeScope.$nodesScope);
            }
        });
    }

    createFolder({ folder }) {
        this.onFolderCreated(
            this.eventEmitter({
                folder
            })
        );
    }

    selectFolder(folder) {
        this.onFolderSelected(
            this.eventEmitter({
                folder
            })
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folder-tree/tree.controller.js